import React from 'react';
import { formatCurrency } from '../utils';
import { useLanguage } from '../../../i18n';

const ProjectDetails = ({ calculationResult }) => {
  const { t } = useLanguage();
  const locale = calculationResult.display_locale || 'de-CH';
  const currency = calculationResult.currency;

  const rows = [
    { label: t('detailLocation'), value: calculationResult.ort || '-' },
    {
      label: t('detailEnergyConsumption'),
      value: Math.round(calculationResult.energieverbrauch_kwh || calculationResult.demand_kwh || 0).toLocaleString(locale)
    },
    {
      label: t('detailHotWater'),
      value: calculationResult.warmwasser === 1 ? 'Ja' : 'Nein'
    },
    {
      label: t('detailHeatingPowerGeo'),
      value: (calculationResult.leistungsbedarf || 0).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
    },
    {
      label: t('detailHeatingPowerAir'),
      value: (calculationResult.leistungsbedarf_luft || 0).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
    },
    {
      label: t('detailSubsidyGeo'),
      value: calculationResult.foerderung === 1 && calculationResult.foerderbetrag_erdwaerme
        ? formatCurrency(calculationResult.foerderbetrag_erdwaerme || 0, currency, locale)
        : 'Nein'
    },
    {
      label: t('detailSubsidyAir'),
      value: calculationResult.foerderung === 1 && calculationResult.foerderbetrag_luftwaerme
        ? formatCurrency(calculationResult.foerderbetrag_luftwaerme || 0, currency, locale)
        : 'Nein'
    },
  ];

  return (
    <div style={{ background: '#fff', borderRadius: '12px', padding: '1.5rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '1.5rem' }} data-testid="project-details-table">
      <h3 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '1rem', color: '#333' }}>{t('projectDetails')}</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={idx} style={{ borderBottom: idx < rows.length - 1 ? '1px solid #f0f0f0' : undefined, borderTop: idx >= 5 ? '1px solid #f0f0f0' : undefined }}>
              <td style={{ padding: '0.75rem 0.5rem', color: '#333' }}>{row.label}</td>
              <td style={{ textAlign: 'right', padding: '0.75rem 0.5rem', fontWeight: '500' }}>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectDetails;
